import React from 'react';

export default function Uputstva() {
  return (
    <div style={{ padding: '2rem', maxWidth: '1000px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>
        Uputstvo za popunjavanje upitnika – po kategorijama
      </h2>

      <Kategorija
        naziv="Kategorija 1: Održivi ekonomski razvoj i partnerstva"
        smjernice={[
          "Upitnik pokriva aktivnosti iz posljednje 2–3 godine.",
          "Odgovori se unose u digitalni obrazac, bez potrebe za dostavljanjem dokaza.",
          "Potrebno je unijeti tačne i provjerljive podatke.",
          "Na kraju se potpisuje izjava o odgovornosti.",
          "Bodovanje se vrši automatski."
        ]}
        kriteriji={[
          "Zapošljavanje i rast zaposlenosti – unos procenta rasta od 2023.",
          "Razvoj MSP-a – unos procenta rasta registrovanih MSP.",
          "Partnerstva – broj razvojnih partnerstava i stanovnika (računa se po glavi).",
          "Digitalne inovacije – barem jedan novi servis u zadnje 2 godine.",
          "Održivost projekata – višestruki izvori finansiranja i plan održavanja."
        ]}
        napomene={[
          "Ako nemate tačne brojke, koristite najbolje dostupne procjene.",
          "Netačni podaci mogu umanjiti ocjenu ili izazvati provjeru."
        ]}
      />

      <Kategorija
        naziv="Kategorija 3: Ekološka održivost i klimatska otpornost"
        smjernice={[
          "Fokus je na klimatskoj otpornosti, zaštiti prirode i ekološkoj svijesti.",
          "Podaci treba da budu realni i provjerljivi.",
          "Period pokrivanja: 2022–2025.",
          "Obavezna izjava o tačnosti."
        ]}
        kriteriji={[
          "Zeleni projekti i energija – broj OIE i energetski efikasnih objekata.",
          "Smanjenje emisije – procentualna razlika CO₂, otpada ili kvaliteta zraka.",
          "Očuvanje prirode – % površine pod zaštitom + edukativne aktivnosti.",
          "Upravljanje otpadom – pristup uslugama i infrastruktura.",
          "Uključenost zajednice – broj učesnika u ekološkim projektima."
        ]}
        napomene={[
          "Nisu neophodni visoki brojevi – važna je inicijativa i rast.",
          "Konsultujte lokalne službe ako nemate podatke."
        ]}
        koraci={[
          "Unesite podatke pažljivo.",
          "Obrazac potpisuje ovlaštena osoba.",
          "Bodovi se izračunavaju automatski."
        ]}
      />

      <Kategorija
        naziv="Kategorija 4: Pametne zajednice i inovacije u urbanizmu"
        smjernice={[
          "Podaci se odnose na period 2023–2025.",
          "Fokus je na inovacijama koje unapređuju kvalitet života.",
          "Izjava o odgovornosti se potpisuje na kraju."
        ]}
        kriteriji={[
          "Pametna rješenja – broj digitalnih servisa po 1.000 stanovnika.",
          "Održivi prijevoz – zeleni vozni park i pristupačnost stanica.",
          "Zeleni gradovi – broj novih javnih prostora.",
          "Digitalna infrastruktura – implementirane pametne komponente.",
          "Smanjenje uticaja – opisne mjere s konkretnim efektima."
        ]}
        napomene={[
          "Koristite procjene iz urbanističkih planova i lokalnih strategija.",
          "Inovativnost je ključna, čak i u manjim JLS."
        ]}
        koraci={[
          "Unesite sve podatke pažljivo.",
          "Potpišite izjavu o tačnosti.",
          "Bodovi se prikazuju automatski."
        ]}
      />
    </div>
  );
}

function Kategorija({ naziv, smjernice, kriteriji, napomene, koraci }) {
  return (
    <div style={{ marginBottom: '3rem' }}>
      <h3 style={{ backgroundColor: '#eef2f7', padding: '1rem', borderRadius: '8px' }}>{naziv}</h3>
      {smjernice && <Sekcija naslov="Opšte smjernice" stavke={smjernice} />}
      {kriteriji && <Sekcija naslov="Uputstvo po kriterijima" stavke={kriteriji} />}
      {napomene && <Sekcija naslov="Napomene" stavke={napomene} />}
      {koraci && <Sekcija naslov="Krajnji koraci" stavke={koraci} />}
    </div>
  );
}

function Sekcija({ naslov, stavke }) {
  return (
    <div style={{ marginTop: '1.2rem' }}>
      <h4 style={{ marginBottom: '0.6rem' }}>{naslov}</h4>
      <ul style={{ paddingLeft: '1.2rem', lineHeight: 1.6 }}>
        {stavke.map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ul>
    </div>
  );
}
